var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatching(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21.5L16 20L17.5 18.5",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20H18C19.6569 20 21 18.6569 21 17",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 21H11C12.1046 21 13 20.1046 13 19V12C13 10.8954 12.1046 10 11 10H5C3.89543 10 3 10.8954 3 12V19C3 20.1046 3.89543 21 5 21Z",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.235 14H19C20.1046 14 21 13.1046 21 12V5C21 3.89543 20.1046 3 19 3H13C11.8954 3 11 3.89543 11 5V7",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 2.5L8 4L6.5 5.5",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4H6C4.34315 4 3 5.34315 3 7",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatching);
export default __webpack_public_path__ + "static/media/matching.89e3ccd066abf87c4bad67dea0e926bf.svg";
export { ForwardRef as ReactComponent };